module.exports = {
      id: "plus-usage",
      viewBox: "0 0 10 10",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#plus",
      toString: function () {
        return this.url;
      }
    }